import UserService from "../services/UserService";
import { FrontPage } from "../pages";

const RenderOnAuthenticated = ({ children }) => {
    return (UserService.isLoggedIn()) ? children : false;
}

export default RenderOnAuthenticated
